import styled from "styled-components";
import {useParams} from "react-router-dom";
import { useEffect } from "react";
import { useProductContext } from "./context/productcontext";
import PageNavigation from "./components/PageNavigation";
import MyImage from "./components/MyImage";
import {Container} from "./styles/Container";
import FormatPrice from "./helpers/FormatPrice";
import { MdSecurity } from "react-icons/md";
import { TbTruckDelivery, TbReplace } from "react-icons/tb";
import Star from "./components/Star";
import AddToCart from "./components/AddToCart";





const API = "https://api.pujakaitem.com/api/products";
const SingleProduct =()=>{
const {getSingleProduct, isSingleLoading, singleProduct}=useProductContext();
  const {id }=useParams();

  // destructing product details from single product
  const{
    id:alias,//changed the name because already have id from url and can name it anything
    name,
    company,price, description, category, stock, reviews, stars, image
  }=singleProduct;


  useEffect(()=>{
getSingleProduct(`${API}?id=${id}`);//adding id of product to url of api, so that we get that prdouct details
  },[]);


  if(isSingleLoading){
    return <div className="page_loading">Loading....</div>;
  }

  return (
  <Wrapper>
<PageNavigation title={name}/>

<Container className="container">
  <div className="grid grid-two-column">
    {/* product images */}
    <div className="product_images">
    <MyImage img={image} />
    </div>

    {/* products data */}
    <div className="product-data">
   <h2>{name}</h2>

   <Star star={stars} review={reviews} />
   

   <p className="product-data-price">
    {/* del- to make number have line drawn over it like delete effect */}
    MRP:
      <del>
        <FormatPrice price={price + 250000}/>
      </del>
   </p>
   <p className="product-data-price product-data-real-price">
    Deal of the Day: <FormatPrice price={price} />
   </p>

<p>{description}</p>

{/* 4 icons */}
<div className="product-data-warranty">
  {/* 1st */}
  <div className="product-warranty-data">
    <TbTruckDelivery className="warranty-icon" />
    <p>Free Delivery</p>
  </div>
{/* 2nd */}
  <div className="product-warranty-data">
                <TbReplace className="warranty-icon" />
                <p>30 Days Replacement</p>
              </div>
{/* 3rd */}
              <div className="product-warranty-data">
                <TbTruckDelivery className="warranty-icon" />
                <p>Thapa Delivered </p>
              </div>
{/* 4th */}
              <div className="product-warranty-data">
                <MdSecurity className="warranty-icon" />
                <p>2 Year Warranty </p>
              </div>
</div>

<div className="product-data-info">
<p>
                Available:
                <span> {stock > 0 ? "In Stock" : "Not Available"}</span>
              </p>
              <p>
                ID : <span> {id} </span>
              </p>
              <p>
                Brand :<span> {company} </span>
              </p>
</div>

<hr />
{/* agar stock me 0 se jyada prdt he tab add to cart show karna hai */}
{stock>0 && <AddToCart product={singleProduct}/>}
    </div>
  </div>
</Container>
  </Wrapper>
  );

}

const Wrapper = styled.section`
  .container {
    padding: 9rem 0;
  }

  //to center the images
  .product_images{
display:flex;
align-items:center;
  }
  .product-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 2rem;

    .product-data-warranty {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ccc;
      margin-bottom: 1rem;

      .product-warranty-data {
        text-align: center;

        .warranty-icon {
          background-color: rgba(220, 220, 220, 0.5);
          border-radius: 50%;
          width: 4rem;
          height: 4rem;
          padding: 0.6rem;
        }
        p {
          font-size: 1.4rem;
          padding-top: 0.4rem;
        }
      }
    }

    .product-data-price {
      font-weight: bold;
    }
    .product-data-real-price {
      color: ${({ theme }) => theme.colors.btn};
    }
    .product-data-info {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 1.8rem;

      span {
        font-weight: bold;
      }
    }

    hr {
      max-width: 100%;
      width: 90%;
      /* height: 0.2rem; */
      border: 0.1rem solid #000;
      color: red;
    }
  }

  .product-images {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    padding: 0 2.4rem;
  }
`;

export default SingleProduct;
